export default __webpack_public_path__ + "static/media/ic-twitter.07441d25.svg";